module.exports = __webpack_public_path__ + "static/media/PDF_34.e1e792d3.pdf";